/**
 * 노션 문서 참조 https://www.notion.so/uniquegoodcompany/DropZone-Image-Uploader-0381876fce3b4417a37088c76845d979
 * 파일 형식이 맞지 않을 때 모달의 본문에 띄워줄 에러 메시지를 반환합니다.
 */
export const dropZoneMessage = {
  mp3: 'mp3 파일을 업로드할 수 있어요',
  image: `jpeg, jpg, png 이미지를 업로드할 수 있어요`
};
